import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { SubmissionError } from 'redux-form';
import axios from './../../../constants/axios';
import alert from 'alertify.js';

import NewProductMainForm from './NewProductMainForm';
import NewProductSubForm from './NewProductSubForm';

class NewProductHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         product_type: 'main'
      };
   }

   changeItemType = (type) => {
      this.setState({
         product_type: type
      });
   };

   saveMainProduct = (product) => {
      const newValues = Object.assign({}, product, {
         item_type_id: 1 // product
      });
      return axios.post('items/productMain', newValues)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Main Product created.');
               this.context.router.push(`/product/productMain/edit/${res.data}/location`);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         });
   };

   saveSubProduct = (product) => {
      const newValues = Object.assign({}, product, {
         item_type_id: 2 // service
      });
      return axios.post('items/productSub', newValues)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Sub Item Variant is created.');
               this.context.router.push('/product');
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         });
   };


   render() {
      return (
         <div>
            <ButtonGroup justified >
               <Button
                  className={this.state.product_type === 'main' ? 'btn-info' : ''}
                  href="#"
                  onClick={() => this.changeItemType('main')} >
                  Main Item
               </Button>
               <Button
                  className={this.state.product_type === 'sub' ? 'btn-info' : ''}
                  href="#"
                  onClick={() => this.changeItemType('sub')} >
                  Sub Item
               </Button>
            </ButtonGroup>
            <hr/>
            {this.state.product_type === 'main' ?
               <NewProductMainForm saveMainProduct={this.saveMainProduct} />
               :
               <NewProductSubForm saveSubProduct={this.saveSubProduct} />}
         </div>
      );
   }
}

NewProductHome.propTypes = {};
NewProductHome.contextTypes = {
   router: React.PropTypes.object
};

export default NewProductHome;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/NewProductHome.js
 **/